import styled from 'styled-components'

export const Container = styled.div`
padding: 1rem;
width: 55rem;
font-size: .75rem;
`

export const ModalHeader = styled.div`
display: flex;
margin-bottom:.5rem;
justify-content: space-between;

h4{
  font-size: 1.25rem;
  font-weight: 700;
}

img{
    margin-right: .125rem;
    height: 2.25rem;
    width: 2.25rem;
    border-radius: 2.5rem;
}
`

export const ModalBody = styled.div`
display: flex;
flex-direction: column;
padding-top: .5rem;
padding: 1rem 1rem 0 1rem;
width: 100%;
margin-bottom: .5rem;

overflow: auto;
max-height:60vh;
::-webkit-scrollbar {
  width: .5rem;
}
/* heigth */
::-webkit-scrollbar {
  height: 0.375rem;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 0.625rem;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
`
